const fontSize = {
    xxxxl: '42px',
    xxxl: '32px',
    xxl: '22px',
    xl: '18px',
    l: '16px',
    m: '14px',
    s: '12px',
    xs: '10px',
}

export default fontSize
export type FontSize = typeof fontSize
